module.exports = __webpack_public_path__ + "static/media/meehoo.ab2fb13f.jpg";